// extracted by mini-css-extract-plugin
export default {"container":"techpackCustomColor_container__gfN3x","containerTitle":"techpackCustomColor_containerTitle__P7Cql"};